<template>
    <LayoutDashboard title="Perfis">
            <v-card outlined>
                <v-card-title>
                    <v-btn color="primary" @click="cadastrarPerfil" outlined v-if="$helper.verificaPermissao('cadastrar-perfil')">Cadastrar</v-btn>
                    <v-spacer></v-spacer>
                    <v-text-field outlined dense v-model="search" append-icon="search" label="Pesquisar" single-line hide-details>
                    </v-text-field>
                </v-card-title>
                <v-card-text>
                    <v-data-table :headers="headers" :items="getPerfis" :search="search" dense>
                        <template v-slot:item.action="{ item }">
                            <v-btn color="primary" outlined small @click="visualizarPerfil(item)" v-if="$helper.verificaPermissao('visualizar-perfil')">Visualizar</v-btn>
                        </template>
                    </v-data-table>
                </v-card-text>
            </v-card>
            <ModalCadastroPerfil v-if="getModalCadastroPerfil" />
    </LayoutDashboard>
</template>

<script>
    import ModalCadastroPerfil from "@/pages/perfil/ModalCadastro"
    import { mapGetters, mapActions } from "vuex"

    export default {
        components: {
            ModalCadastroPerfil
        },
        data() {
            return {
                search: '',
                headers: [
                    { text: '#', value: 'id', sortable: false },
                    { text: 'Perfil', align: 'left', sortable: false, value: 'perfil'},
                    { text: 'Funcionários', align: 'left', sortable: false, value: 'funcionarios_count'},
                    { text: 'Ações', value: 'action', sortable: false }
                ],
                funcionarios: [],
            }
        },
        computed: {
            ...mapGetters([
                'getModalCadastroPerfil',
                'getPerfis'
            ])
        },
        methods: {
            ...mapActions([
                'listarPerfil',
                'visualizarPerfil',
                'cadastrarPerfil',
                'listarPermissao'
            ])
        },
        created() {
            this.listarPerfil()
        }
    }
</script>